import React, { useEffect, useState } from "react";
import axios from "axios";
import CrossIcon from "../../Assests/Dashboard/cross.svg";
import { fetchAttributesData } from "../../Redux/features/Attributes/attributesSlice";
import { useSelector, useDispatch } from "react-redux";
import { BASE_URL, ADD_ATTRIBUTE } from "../../Constants/Config";
import AddIcon from "../../Assests/Category/addIcon.svg";

import DraggableTable from "../../reuseableComponents/DraggableTable";
import { Box, Modal } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { useAuthDetails } from "../../Common/cookiesHelper";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import PasswordShow from "../../Common/passwordShow";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchPermissions } from "../../Redux/features/Authentication/permissionsSlice";

const AtrDataList = ({ seVisible }) => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const [loader, setLoader] = useState(false);
  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  useEffect(() => {
    getfetchAttributesData();
  }, []);
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  useEffect(() => {
    const emp_id = window.localStorage.getItem("emp_id");
    if (emp_id !== null && emp_id !== undefined) {
      const requestData = { emp_id: emp_id };
      dispatch(fetchPermissions(requestData));
    }
  }, [dispatch]);
  const getfetchAttributesData = async () => {
    try {
      let data = {
        merchant_id: merchant_id,
        ...userTypeData,
      };
      if (data) {
        await dispatch(fetchAttributesData(data)).unwrap();
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setNewAttribute("");
    setShowModal(false);
    setErrorMessage();
  };

  //sachin code start
  //add
  const [errorMessage, setErrorMessage] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [newAttribute, setNewAttribute] = useState("");
  const [submitmessage, setsubmitmessage] = useState("");
  const [nameExists, setNameExists] = useState("");

  const [allattributes, setallattributes] = useState([]);
  const AllAttributesDataState = useSelector((state) => state.attributes);

  useEffect(() => {
    if (
      !AllAttributesDataState.loading &&
      AllAttributesDataState.attributesData
    ) {
      setallattributes(AllAttributesDataState.attributesData);
    }
  }, [
    AllAttributesDataState,
    AllAttributesDataState.loading,
    AllAttributesDataState.attributesData,
  ]);

  const changeTittleHandler = (value) => {
    // let value = event.target.value;
    const regex = /^[A-Za-z0-9 ]*$/;
    const space = /^(?!\s).*/;
    if (space.test(value)) {
      if (regex.test(value) || value === "") {
        setNewAttribute(value);
        const nameExists = allattributes.some(
          (item) => item.title.toLowerCase() === value.toLowerCase()
        );
        if (nameExists) {
          setErrorMessage("Attribute name already exists");
          setNameExists(true);
        } else {
          setErrorMessage("");
          setNameExists(false);
        }
      } else {
        setErrorMessage("Special characters are not allowed");
      }
    }
  };

  const handleAddAttribute = async () => {
    if (nameExists) {
      return false;
    }
    if (!newAttribute.trim()) {
      // Check if newAttribute is empty or only contains whitespace
      setErrorMessage("Title is required");
      return;
    }
    setLoader(true);
    try {
      const newItem = {
        merchant_id: merchant_id,
        title: newAttribute,
        login_employee_id: LoginGetDashBoardRecordJson?.employee_id
          ? LoginGetDashBoardRecordJson?.employee_id
          : null,
        token_id: userTypeData?.token_id,
        login_type: userTypeData?.login_type,
      };
      const data = newItem;
      const response = await axios.post(BASE_URL + ADD_ATTRIBUTE, newItem, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });
      if (response) {
        setShowModal(false);
        ToastifyAlert("Added Successfully", "success");
        setNewAttribute("");
        let merchantdata = {
          merchant_id: merchant_id,
          ...userTypeData,
        };
        if (merchantdata) {
          dispatch(fetchAttributesData(merchantdata));
        }
      } else {
        setsubmitmessage(response.data.message);
        setNewAttribute("");
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    } finally {
      setLoader(false);
    }
  };

  const handleOpen = () => setShowModal(true);
  const handleClose = () => {
    setNewAttribute("");
    setErrorMessage("");
    setShowModal(false);
  };

  const myStyles = {
    // width: "90%",
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontFamily: "'CircularSTDMedium', sans-serif !important",
  };

  const handleKeyPress = (event) => {
    if (event.key === ",") {
      event.preventDefault();
    }
  };

  const [defaultList, setDefaultList] = useState([]);
  const qcList = useSelector((state) => state.qclist);

  useEffect(() => {
    if (qcList?.qcList?.length) {
      const defaultList = qcList.qcList.filter((item) => {
        return item.type === "Attribute" && item.show_dropdown === "1";
      });
      setDefaultList(() => [...defaultList]);
    }

    return () => {
      setDefaultList([]);
    };
  }, [qcList]);

  return (
    <>
      <div className="box">
        <div className="q-attributes-bottom-detail-section">
          <div container className="q-attributes-bottom-header-sticky">
            <div className="q-attributes-bottom-header">
              <span className="mx-3 my-3 md:mx-0 md:my-0">
                Product Attributes
              </span>
              <p className="mx-3 md:mx-0" onClick={openModal}>
                Add Attribute <img src={AddIcon} alt="add-icon" />
              </p>
            </div>
          </div>

          <DraggableTable
            tableHead={["Sort", "Title", "", ""]}
            tableRow={allattributes}
            setFunction={setallattributes}
            editAttributeObj={true}
            table={"varients"}
            loading={AllAttributesDataState.loading}
          />

          <Modal
            open={showModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              className="view-category-item-modal"
              sx={{ width: { xs: "95%", md: "60%" } }}
              style={myStyles}
            >
              <div
                className="q-add-categories-section-header text-[18px]"
                style={{
                  justifyContent: "space-between",
                  fontFamily: "CircularSTDBook",
                }}
              >
                <span style={{ cursor: "unset" }}>Add Attribute</span>

                <div>
                  <img
                    src={CrossIcon}
                    alt="icon"
                    className="  quic-btn-cancle w-6 h-6 cursor-pointer"
                    onClick={() => handleClose()}
                  />
                </div>
              </div>

              <div className="view-category-item-modal-header">
                <div
                  className="title_attributes_section "
                  style={{ margin: "1rem 1rem" }}
                >
                  <label className="mb-2">Title</label>
                  <Autocomplete
                    id="size-small-standard"
                    size="small"
                    options={defaultList}
                    freeSolo
                    getOptionLabel={(option) => {
                      // Check if the option is an object with a name property
                      if (typeof option === "object" && option.name) {
                        return option.name;
                      }
                      // Handle other types of options, e.g., strings
                      return typeof option === "string" ? option : "";
                    }}
                    value={newAttribute}
                    onChange={(event, newValue) => {
                      changeTittleHandler(newValue?.name || "");
                    }}
                    renderOption={(props, option, { index }) => (
                      <li {...props} key={index}>
                        {typeof option === "object" ? option.name : option}
                      </li>
                    )}
                    // disabled={props.controltext}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        maxLength={35}
                        onKeyPress={handleKeyPress}
                        className="suggestlist_input MuiAutocomplete-option"
                        name="brand"
                        value={newAttribute}
                        placeholder="Enter attribute title"
                        onChange={(e) => changeTittleHandler(e.target.value)}
                        inputProps={{
                          ...params.inputProps,
                          inputMode: "text", // This sets the input mode for text input
                          autoCapitalize: "words", // This enables capitalizing the first letter of each word
                        }}
                      />
                    )}
                  />
                  <span className="input-error">
                    {errorMessage !== "" ? errorMessage : ""}
                  </span>
                </div>
              </div>

              <div className="q-add-categories-section-middle-footer">
                <button
                  onClick={handleAddAttribute}
                  className="quic-btn quic-btn-save attributeUpdateBTN"
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <CircularProgress
                        color={"inherit"}
                        className="loaderIcon"
                        width={15}
                        size={15}
                      />{" "}
                      Add
                    </>
                  ) : (
                    "Add"
                  )}
                  {/* Add */}
                </button>
                <button
                  onClick={closeModal}
                  className="quic-btn quic-btn-cancle"
                >
                  Cancel
                </button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AtrDataList;
